export default __webpack_public_path__ + "static/media/18.9d561cd6.png";